import { OrderStatus, OrderType } from 'types/shared';
import { z } from 'zod';

const orderResponseSchemas = {
  getOrdersByTypeAndStatus: z.object({
    success: z.boolean(),
    message: z.string(),
    orders: z.array(
      z.object({
        ordertype: z.nativeEnum(OrderType),
        status: z.nativeEnum(OrderStatus),
        orderId: z.number(),
        userId: z.number(),
        orderDate: z.string().datetime(),
        companyName: z.string(),
        orderNumber: z.string(),
        orderedBy: z.string(),
        orderedSims: z.number(),
      })
    ),
    ordersCount: z.number(),
  }),
  approveOrRejectPendingOrder: z.object({
    success: z.boolean(),
    message: z.string(),
  }),
  getOrderDetailsById: z.object({
    success: z.boolean(),
    message: z.string(),
    order: z.object({
      ordernumber: z.string(),
      orderSimsCount: z.number(),
      sims: z.array(
        z.object({
          simnumber: z.string(),
          ultraplan: z.string(),
          status: z.number(),
          msisdn: z.string(),
          planid: z.number(),
        })
      ),
    }),
  }),
};

export default orderResponseSchemas;
